import {getResultsFromDuckDB} from "@/web-worker/duckdb"

const duckDBCalls = {
  getResultsFromDuckDB
}

addEventListener("message", (event) => {
  postMessage({ key: "queryStarted", value: true })
  const functionName = event.data.method
  const workerName = event.data.workerName

  if (Object.keys(duckDBCalls).includes(functionName)) {
    duckDBCalls[functionName](...event.data.args).then(duckResult => {
      let dict = {
        "getResultsFromDuckDB": "done"
      }

      postMessage({key: dict[functionName], value: {result: duckResult, workerName: workerName}})
    })

  } else {
    postMessage({
      key: "error",
      value: `No calculation found ${functionName ? `for type ${functionName}` : ""}`
    })
  }

  postMessage({ key: "queryStarted", value: false })
})
